<template>
  <div class="modal"
       id="modal-update-subtest-attempt-platform"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ translate('previews.subtest-attempt.buttons.update-platform') }}
          </h5>
        </div>

        <div class="modal-body">
          <form role="form">
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right" for="platform">
                {{ translate('modals.update-platform.form.platform') }}
              </label>
              <div class="col-md-6">
                <select id="platform"
                        name="platform"
                        class="form-control"
                        v-model="updateSubtestAttemptPlatformForm.platform">
                  <option value="skype">Skype</option>
                  <option value="zoom">Zoom</option>
                  <option value="jitsi-meet">Jitsi Meet</option>
                  <option value="meet-google">Meet Google</option>
                </select>

                <span class="invalid-feedback"
                      v-if="updateSubtestAttemptPlatformForm.errors.has('platform')">
                    <strong>{{ updateSubtestAttemptPlatformForm.errors.get('platform') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right" for="platform_id">
                Link / User
              </label>
              <div class="col-md-6">
                <input class="form-control"
                       id="platform_id"
                       type="text"
                       name="platform_id"
                       v-model="updateSubtestAttemptPlatformForm.platform_id">
              </div>

            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal">
            {{ translate('modals.update-platform.cancel') }}
          </button>
          <button type="button"
                  class="btn btn-success"
                  @click.prevent="updatePlatform"
                  :disabled="updateSubtestAttemptPlatformForm.busy">
            {{ translate('modals.update-platform.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['subtestAttempt'],

  /**
   * The component's data.
   */
  data () {
    return {
      updateSubtestAttemptPlatformForm: new AppForm({
        platform: null,
        platform_id: null,
      }),
    };
  },

  mounted () {
    this.updateSubtestAttemptPlatformForm.platform = this.subtestAttempt.platform;
    this.updateSubtestAttemptPlatformForm.platform_id = this.subtestAttempt.platform_id;
  },

  methods: {
    updatePlatform () {
      let self = this;

      App.put('/api/subtest-attempts/' + this.subtestAttempt.id + '/platform', this.updateSubtestAttemptPlatformForm)
        .then(() => {
          $('#modal-update-subtest-attempt-platform').modal('hide');

          self.updateSubtestAttemptPlatformForm.platform = null;
          self.updateSubtestAttemptPlatformForm.platform_id = null;

          self.$parent.$emit('getSubtestAttempt', self.subtestAttempt.id);
        });
    },
  }
};
</script>
